import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class ComponentsActivationDto extends InspectionCase {
  item_14_1?: InspectionValueCase;
}

export class ComponentsActivation extends ComponentsActivationDto {
  constructor(
    data: ComponentsActivationDto = { title: 'בדיקת הפעלת כל הרכיבים באתר' }
  ) {
    super(data);
    this.item_14_1 = new InspectionValueCase({
      ...data.item_14_1,
      title: `יש לציין את הכתובות כפי שמתקבלות ברכזת`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      !this.item_14_1.isApplicable ||
      this.item_14_1.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.item_14_1.getNotes()];
  }
}
